/** Shared Zainematics brand assets (local public files). */
export const BRAND = {
  name: "Zainematics",
  tagline: "For the Love of Learning",
  /** Served from client/public */
  logoSrc: "/zainematics-logo.png",
};
